import React from 'react'
import './QuienesSomos.css'

export const QuienesSomos = () => {
  return (
    <section className='quienesSomos'>
        <h1>¿Quiénes somos?</h1>
        <article>
            <p>Somos una empresa dedicada a la fabricación y venta de productos de decoración, higiene y estética natural.
            Creemos en la posibilidad de cambiar hábitos concientizando sobre el cuidado del medioambiente y promoviendo la utilización de productos, ya sea de deco y/o de cosmética, que no tengan origen ni testeo animal. Al mismo tiempo, combinamos el arte de la aromaterapia utilizando esencias puras en nuestros productos y de esta manera aportar mayores beneficios que mejoren el bienestar físico y mental de nuestros clientes.</p>            
        </article>
        <article>
            <h2>Visión</h2>
            <p>Convertirnos en una empresa reconocida por ofrecer productos de calidad que combina los usos cotidianos con la aromaterapia y, a su vez, concientiza sobre el cuidado del medio ambiente.</p>
        </article>
        <article>
            <h2>Misión</h2>
            <p>Concientizar utilizando insumos de origen vegetal, renovable y reutilizable para la creación de todos nuestros productos con el fin de otorgarle al cliente un producto de satisfaga su necesidad y cree valor.</p>
        </article>
    </section>
  )
}
